module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/blocks/table-header/table-header.component.css
// module id = ./src/app/component/blocks/table-header/table-header.component.css
// module chunks = main